import { Voucher } from '@src/core/buyerApiClient';
import { LayoutColors } from '@src/core/theme';
import React from 'react';
import { FiDownloadCloud } from 'react-icons/fi';
import styled from 'styled-components';
import { Theme, useMediaQuery } from '@planne-software/uni/mui/material';
import DotFalling from '@src/components/reusable/spinner/DotFalling';
import { baseButton } from '../shared';

type ReservationDownloadButtonProps = {
  hasMultipleVouchers: boolean;
  text: string;
  isVoucherPdfLoading: (voucher: Voucher) => boolean;
  onOpenVoucherPdfButtonClick: (voucher: Voucher) => void;
  vouchers: Voucher[];
};

const ReservationDownloadButton = (props: ReservationDownloadButtonProps) => {
  const { hasMultipleVouchers, text, isVoucherPdfLoading, onOpenVoucherPdfButtonClick, vouchers } = props;
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const isSplitSingle = vouchers.length === 1;
  const shouldShowSingleVoucherDownload = !hasMultipleVouchers || (isMobile && isSplitSingle);
  const firstVoucher = vouchers[0];

  if (!firstVoucher) {
    return null;
  }

  if (shouldShowSingleVoucherDownload) {
    return (
      <Button onClick={() => onOpenVoucherPdfButtonClick(firstVoucher)}>
        {isVoucherPdfLoading(firstVoucher) ? (
          <DotFalling />
        ) : (
          <>
            <FiDownloadCloud color={LayoutColors.whiteLight} size={22} />
            <ReservationViewText>{text}</ReservationViewText>
          </>
        )}
      </Button>
    );
  }

  return null;
};

export default ReservationDownloadButton;

const ReservationViewText = styled.span`
  display: inline;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  text-transform: uppercase;
`;

const Button = styled.button`
  ${baseButton};

  color: ${LayoutColors.whiteLight};
  background: ${LayoutColors.justBlue};
  white-space: nowrap;

  & > svg {
    flex-shrink: 0;
  }
`;
